<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <div slot="header">
            <strong>{{ client.surname }} {{ client.name }}, client n° {{ client.id }} - {{ client.lastOrder }}{{ client.saisiepar }}</strong>
          </div>
          <div class="row">
            <div class="col-md-12">
              <p>Entrer une référence produit ou un nom, et la quantité (elle remplace les quantités déjà saisies en cas de doublon)</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2"><p class="align-text-bottom">Date de mise à disposition</p></div>
            <div class="col-md-2"><input type="date" autofocus class="form-control" v-model.trim="order.deliveryDate" name="datedemiseadispo" v-on:change="onOrderModified"/></div>
          </div>
          <div class="row">
            <div class="col-md-12 py-2">
              <input type="text" class="form-control" v-model.trim="order.comment" placeholder="commentaire" v-on:change="onOrderModified">
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <!--b-form-fieldset label="Référence"-->
              <autocomplete
              url="http://non-existent"
              anchor="ref"
              label="name"
              placeholder="Réference"
              :options="searchedRefs"
              :min="2"
              :debounce="200"
              :onSelect="autoSelect"
              ref="idref"
              :autofocus="true"
              :onShouldGetData="getDataRef">
            </autocomplete>
          </div><!--/.col-->
          <div class="col-md-5">
            <autocomplete
            url="http://non-existent"
            anchor="name"
            label="ref"
            placeholder="Nom du produit"
            :classes="{ input: 'col-md-12', wrapper: 'col-md-12', list: 'data-list col-md-12', item: 'data-list-item col-md-12' }"
            :options="searchedProduct"
            :min="3"
            :debounce="200"
            :onSelect="autoSelect"
            ref="descref"
            :onShouldGetData="getDataRef">
          </autocomplete>
        </div><!--/.col-->
        <b-form-select required v-model="data.container" :options="optionsContainer" class="col-md-1" ref="container">
        </b-form-select>
        <div class="col-md-2">
          <b-form-input lang="en-US" v-on:keyup.enter="addRef" type="number" step=".01" id="qty" min="0.0" v-model.trim="data.quantity"></b-form-input>
        </div><!--/.col-->
        <b-form-select required v-model="data.unite" :options="optionsUnite" class="col-md-1" ref="unite">
        </b-form-select>
        <div class="col-md-1 mx-auto">
          <b-button type="submit" size="lg" variant="link" v-on:click="addRef"><i class="fa fa-cart-plus"></i></b-button>
        </div>
      </div><!--/.row-->
    </b-card>
  </div><!--/.col-md-12 -->
</div><!--/.row-->
<div class="row">
  <div class="col-md-12">
    <b-card>
      <div slot="header">
        <strong>Commande en cours {{ order.label }}</strong>
      </div>
      <b-button type="submit" :disabled="! createBtnEnabled" size="sm" variant="success" v-on:click="validateOrder"><i class="fa fa-handshake-o"></i> Valider la commande</b-button>
      <b-button type="submit" :disabled="! deleteBtnEnabled" size="sm" variant="warning" v-on:click="deleteOrder"><i class="fa fa-eraser"></i> Supprimer la commande</b-button>
      <b-button type="submit" size="sm" variant="error" v-on:click="backClientView"><i class="fa fa-eraser"></i> Annuler les modifications</b-button>
      <p></p>
      <table class="table table-bordered table-striped table-sm table-hover">
        <thead>
          <tr>
            <th>ref</th>
            <th>Produit</th>
            <th></th>
            <th>Qté</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr is="order-row" v-for="row in orderRows" v-bind:key="row.id" v-bind:row="row" v-on:del="delRow">
          </tr>
        </tbody>
      </table>
    </b-card>
  </div><!--/.col-md-12 -->
</div><!--/.row-->
</div><!-- whole page -->
</template>
<script>
import store from '@/store'
import router from '@/router'
import Autocomplete from 'vue2-autocomplete-js'
import Datepicker from 'vuejs-datepicker'

var orderComponent = {
  template: '<tr><td>{{ row.ref }}</td><td>{{ row.name }}</td><td>{{ row.container }}</td><td>{{ row.quantity }}</td><td>{{ row.unite }}</td><td style="cursor: pointer" v-on:click="$emit(\'del\', row.ref )"><i class="fa fa-trash-o"/></td></tr>',
  props: ['row']
}

export default {
  name: 'clientOrder',
  components: {
    'order-row': orderComponent,
    autocomplete: Autocomplete,
    datepicker: Datepicker
  },
  data: function () {
    return {
      // data contient la ligne de commande
      data: {
        ref: '',
        name: '',
        quantity: 1,
        unit_price: 0.0,
        container: 'vrac',
        unite: 'piece'
      },
      client: {
        name: '',
        surname: '',
        lastOrder: 'nouvelle commande',
        saisiepar: ''
      },
      order: {
        label: '',
        comment: '',
        deliveryDate: new Date()
      },
      orderRows: [],
      searchedRefs: [],
      searchedProduct: [],
      createBtnEnabled: false,
      showModalError: false,
      showModalValidation: false,
      showModalDelete: false,
      showModalLeave: false,
      lastError: '',
      deleteBtnEnabled: false,
      notBeforeNow: {to: new Date()},
      orderModified: false,
      optionsContainer: [
        {value: 'vrac', text: 'Vrac'},
        {value: 'sous-vide', text: 'Sous-Vide'}
      ],
      optionsUnite: [
        {value: 'piece', text: 'Pièce'},
        {value: 'kg', text: 'Kg'}
      ]
    }
  },
  watch: {
    order: {
      handler: function () {
        if (this.orderRows.length > 0) {
          this.onOrderModified()
          this.deleteBtnEnabled = true
        }
      },
      deep: true
    }
  },
  beforeCreate () {
    if (!store.state.isLogged) {
      router.go({name: 'login'})
    }
  },
  created () {
    // récupérer les données lorsque la vue est créée et
    // que les données sont déjà observées
    this.fetchData()
  },
  beforeRouteLeave (to, from, next) {
    console.log('beforeRouteUpdate')
    if (this.orderModified) {
      const answer = window.confirm('La commande n\'a pas été validée. Quittez ?')
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  methods: {
    handleValidate () {
      this.showModalValidation = false
      console.log('ok')
      this.realValidateOrder()
    },
    handleDelete () {
      this.showModalDelete = false
      console.log('delete')
      this.realDeleteOrder()
    },
    handleLeave () {
      this.showModalLeave = false
    },
    onOrderModified () {
      this.createBtnEnabled = true
      this.orderModified = true
      console.log('order modified')
    },
    // search reference matching user request, and fill component
    getDataRef (obj) {
      return new Promise((resolve, reject) => {
        console.log('searching for good called ' + obj)
        this.$Progress.start()
        this.$http.get(process.env.API_URL + '/goods/search', {params: {'ref': obj}}).then((response) => {
          this.$Progress.finish()
          console.log(response.body)
          if (response.body.length === 1) {
            console.log('only one answer: ' + response.body[0].ref)
            this.$refs.idref.setValue(response.body[0].ref)
            this.$refs.descref.setValue(response.body[0].name)
            this.data.ref = response.body[0].ref
            this.data.name = response.body[0].name
          }
          resolve(response.body)
        },
        (error) => {
          console.log('ref search failed ' + error.status)
          if (error.status === 403) {
            this.$eventHub.$emit('redirectToLogin')
          }
          reject(new Error('ref search failed'))
        })
      })
    },
    autoSelect (obj) {
      // user selected an item in dropdown list
      console.log('selected ' + obj.ref)
      this.$refs.idref.setValue(obj.ref)
      this.$refs.descref.setValue(obj.name)
      obj.container = 'vrac'
      obj.unite = 'piece'
      obj.quantity = 1
      this.data = obj
    },
    addRef () {
      // method called when a new ref should be added to order
      var qty = this.data.quantity
      console.log('addRef ' + this.data.ref + ' ' + qty)
      if (this.data.quantity > 0 && this.data.name !== '' && this.data.ref !== '') {
        // search for already entered references
        var modified = false
        for (var i = 0; i < this.orderRows.length && !modified; i++) {
          if (this.orderRows[i].ref === this.data.ref && this.orderRows[i].container === this.data.container) {
            modified = true
            this.orderRows.splice(i, 1, Object.assign({}, this.data))
          }
        }
        if (!modified) {
          // new line
          this.orderRows.push(Object.assign({}, this.data))
        }
        // then, empty data
        this.data.ref = ''
        this.data.name = ''
        this.data.quantity = 1.0
        this.data.unit_price = 0.0
        this.$refs.idref.setValue('')
        this.$refs.descref.setValue('')
        this.createBtnEnabled = true
      } else {
        console.log('addRef ' + this.data.ref + ' ignored')
      }
    },
    fetchData () {
      // when page is loading, fetch latest order informations
      console.log('fetchData: ' + this.$route.params.id + ' / ' + this.$route.params.orderid)
      this.client.id = this.$route.params.id
      if (parseInt(this.$route.params.orderid) === 0) {
        this.deleteBtnEnabled = false
        this.order.comment = ''
        var now = new Date()
        var sprintf = require('sprintf-js').sprintf
        this.order.deliveryDate = sprintf('%d-%02d-%02d', now.getFullYear(), now.getMonth() + 1, now.getDate())
        console.log('fetchData: new order for ' + this.order.deliveryDate + ' (yes, a date)')
      } else {
        this.$Progress.start()
        console.log('fetchData / ' + this.client.id + ' / ' + this.$route.params.orderid)
        var orderReq = { 'client': this.client.id, 'order': this.$route.params.orderid }
        this.$http.get(process.env.API_URL + '/order/get', {params: orderReq}).then((response) => {
          this.$Progress.finish()
          console.log('response: ' + response.body)
          for (var i = 0; i < response.body.lines.length; i++) {
            this.orderRows.splice(i, 1, Object.assign({}, response.body.lines[i]))
          }
          this.client.lastOrder = response.body.order
          this.client.saisiepar = ', saisie par ' + response.body.operator
          console.log(response.body.delivery)
          this.order.deliveryDate = response.body.delivery
          this.order.comment = response.body.comment
          this.deleteBtnEnabled = (this.client.lastOrder > 0)
          this.orderModified = false
        },
        (error) => {
          console.log('error on fetchData')
          this.$Progress.fail()
          if (error.status === 403) {
            this.$eventHub.$emit('redirectToLogin')
          }
          // console.log(error.body)
        })
      }
      this.$http.get(process.env.API_URL + '/customer/get', {params: {'id': this.client.id}}).then((response) => {
        this.$Progress.finish()
        console.log('Order for ' + response.body.name + ' ' + response.body.surname)
        this.client.name = response.body.name
        this.client.surname = response.body.surname
      },
      () => {
        this.$Progress.fail()
      })
    },
    delRow (ref) {
      // remove order line
      this.$Progress.start()
      var localOrder = []
      console.log('del row: ' + ref)
      this.orderRows.forEach(function (row) {
        if (row.ref !== ref) {
          localOrder.push(row)
        }
      })
      this.orderRows = localOrder
      this.$Progress.finish()
      this.createBtnEnabled = (this.orderRows.length > 0)
    },
    backClientView () {
      this.orderModified = false
      this.$router.push({'name': 'Client'})
    },
    validateOrder () {
      this.showModalValidation = true
      this.handleValidate()
    },
    deleteOrder () {
      this.showModalDelete = true
      this.handleDelete()
    },
    realValidateOrder () {
      this.createBtnEnabled = false
      this.$Progress.start()
      var order = {}
      order.client = this.client.id
      order.delivery = this.order.deliveryDate
      order.comment = this.order.comment
      var id = parseInt(this.$route.params.orderid)
      if (id > 0) {
        order.id = id
      }
      order.rows = []
      for (var i = 0; i < this.orderRows.length; i++) {
        order.rows.push(this.orderRows[i])
      }
      console.log('creating order with ' + this.orderRows.length + ' lines (sending ' + order.rows.length + ')')
      this.$http.post(process.env.API_URL + '/order/create', order).then((response) => {
        this.$Progress.finish()
        this.createBtnEnabled = true
        this.$notify({
          group: 'main',
          title: 'Commande client',
          text: 'La commande a bien été enregistrée sous le numéro ' + response.body.order_id + '.',
          duration: 5000
        })
        order.orderid = response.body.order_id
        this.orderModified = false
        this.$http.post(process.env.API_URL + '/order/send-email', order).then((response2) => {
          this.$Progress.finish()
          this.$notify({
            group: 'main',
            title: 'Commande client',
            text: 'Un mail de confirmation a été envoyé au client pour la commande ' + order.orderid + '.',
            duration: 5000
          })
        })
        router.push({name: 'Client'})
      },
      (error) => {
        this.$Progress.fail()
        this.createBtnEnabled = true
        this.lastError = error.body
        this.showModalError = true
      })
    },
    realDeleteOrder () {
      const answer = window.confirm('Etes vous sûr de vouloir supprimer la commande ?')
      if (answer) {
        this.deleteBtnEnabled = false
        this.$Progress.start()
        var order = {}
        order.client = this.client.id
        order.orderId = this.client.lastOrder
        console.log('delete order ' + order.client)
        this.$http.post(process.env.API_URL + '/order/delete', order).then((response) => {
          this.$Progress.finish()
          this.createBtnEnabled = true
          this.$notify({
            group: 'main',
            title: 'Commande client ' + this.client.id,
            text: 'La commande a bien été supprimée.',
            duration: 2500
          })
          this.orderModified = false
          router.push({name: 'Client'})
        },
        (error) => {
          this.$Progress.fail()
          this.deleteBtnEnabled = true
          this.lastError = error.body
          this.showModalError = true
        })
      }
    }
  }
}
</script>
<style>
.autocomplete-list {
  z-index: 9998;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// ClientOrder.vue?7e484dbe